export default "/ba6dbdc25d4b1eff78902568597981de.jpg";